module.exports = __webpack_public_path__ + "static/img/2022.0de1cb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022.jpg
// module id = 312
// module chunks = 0